import find from 'lodash/find';
import { put, fork, take, select, throttle } from 'redux-saga/effects';
import { takeFetch } from 'redux/helpers';
import { routeActions } from 'ng-redux-route';
import * as serviceActions from '../../../services/actions';
import * as actions from './actions';


function* getCompanyListSuccess() {
  const { success } = yield takeFetch(serviceActions.api.configuration.company.GET_LIST);
  if (success) {
    yield put(actions.init.company.begin({ values: success.data }));
  }
}

function* getProjectList() {
  const { success } = yield takeFetch(serviceActions.api.configuration.project.GET_LIST);
  if (success) {
    yield put(actions.setProjectList({ values: success.data }));
  }
}

function* fetchSearch() {
  const { params } = yield select(state => state.router);
  yield put(serviceActions.api.configuration.project.getList.request({
    q: params.q,
    groupId: params.company,
    userId: params.user,
  }));
  yield fork(getProjectList);
}

function* invalidate() {
  while (true) {
    yield take(actions.INVALIDATE.BEGIN);
    const { params } = yield select(state => state.router);
    const inactive = params.inactive === true;
    const { projectList } = yield select(state => state.configuration.project.viewer);
    const items = projectList.filter(val => inactive || val.isActive);
    yield put(actions.invalidate.end({ items }));
  }
}

function* init() {
  while (true) {
    yield take(actions.INIT.BEGIN);
    yield put(serviceActions.api.configuration.company.getList.request());
    yield fork(getCompanyListSuccess);
    const { params } = yield select(state => state.router);
    yield put(actions.init.end({ initParams: params }));
  }
}

function* initCompany() {
  while (true) {
    const { values } = yield take(actions.INIT.COMPANY.BEGIN);
    const { params } = yield select(state => state.router);

    const companyOptions = values.filter(c=> c.isActive).map(c => ( { id: c.companyId, title: c.name }));
    const groupId = Number(params.company) || ttb.constants.routing.PROJECT_GROUP_ID;
    let selectedCompany = find(companyOptions, c => c.id === groupId);
    if(!selectedCompany && companyOptions.length > 0)
    {
      selectedCompany = companyOptions[0];
    }
    if(companyOptions.length > 0)
    {
    yield put(routeActions.setLocation([
      { fn: 'search', args: ['company', selectedCompany.id] },
      { fn: 'replace' },
    ]));
  }
    yield put(actions.init.company.end({ companyOptions, selectedCompany }));
    yield put(actions.search());
  }
}

function* throttleSearch() {
  yield throttle(500, actions.SEARCH, fetchSearch);
}

function* setProjectList() {
  while (true) {
    yield take(actions.SET_PROJECT_LIST);
    yield put(actions.invalidate.begin());
  }
}

export default function* viewer() {
  yield fork(invalidate);
  yield fork(init);
  yield fork(initCompany);
  yield fork(throttleSearch);
  yield fork(setProjectList);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/viewer/saga.js